function StrokeCS() {
  return (
    <>
            <g>			
        {/* viền hội trường */}
        <path fill="none" stroke="#000000" stroke-width="0.95" stroke-miterlimit="10" d="M1660.703,962.45v-97.53h-494.32v97.53
          c-221.36-32.29-422.69-107.14-588.54-212.86l84.79-246.06h297.2v-91.49h-28.09V145.52h963.6v266.52h-28.101v91.49h297.2
          l84.8,246.07C2083.394,855.31,1882.063,930.16,1660.703,962.45z"/>
        <path fill="none" stroke="#000000" stroke-width="0.95" stroke-miterlimit="10" d="M2267.911,803.771l-18.668-54.171
          c-165.85,105.71-367.18,180.56-588.54,212.85v-97.53h-494.32v97.53c-221.36-32.29-422.69-107.14-588.54-212.86l-17.439,50.607"/>
        <path fill="none" stroke="#000000" stroke-width="0.95" stroke-miterlimit="10" d="M528.682,892.251L88.313,2170.15
          c379.4,192.58,835.11,312.673,1325.23,312.673c490.121,0,945.82-120.093,1325.22-312.684L2300.677,898.854"/>	
          {/* 3 bàn chủ tịch trên sân khấu */}
          {/* <rect x="1050.363" y="292.4" fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" width="726.36" height="33.6"/> */}
          <rect x="1050.363" y="383.373" fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" width="726.36" height="33.6"/>
          <rect x="1050.363" y="474.345" fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" width="726.36" height="33.6"/>
          <text x="1212.631"  y="557.088"
              fill="black"
              fontSize="35"
            >ĐOÀN CHỦ TỊCH ĐẠI HỘI
          </text>
          {/* bàn thư ký hội nghị */}
          <rect x="740.207" y="652.005" transform="matrix(0.9304 -0.3664 0.3664 0.9304 -189.9181 357.8888)" fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" width="215.039" height="54.374"/>
          <text x="849.434" y="710.956" 
                fill="black"
                textAnchor="middle"
                fontSize="25"
                transform="rotate(-20, 789.434, 696.956)"
              >THƯ KÝ ĐẠI HỘI
            </text>

          {/* bục phát biểu */}
          <rect x="1864.834" y="736.16" transform="matrix(0.9961 0.0877 -0.0877 0.9961 74.8317 -163.565)" fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" width="66.754" height="66.755"/>
          <text x="1830.134" y="718.966"
              fill="black"
              fontSize="22"
              transform="rotate(5, 1846.134, 708.966)"
            >BỤC PHÁT BIỂU
          </text>
          {/* lối lên sân khấu */}
          <polyline fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" points="596.453,695.586 649.113,727.16 
          630.009,781.15 	"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="582.41" y1="736.338" x2="634.748" y2="767.759"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="587.086" y1="722.769" x2="639.463" y2="754.434"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="591.777" y1="709.155" x2="644.405" y2="740.468"/>
          <polyline fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" points="2230.48,695.586 2177.82,727.16 
          2196.925,781.15 	"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="2244.524" y1="736.338" x2="2192.187" y2="767.759"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="2239.848" y1="722.769" x2="2187.471" y2="754.434"/>
          <line fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" x1="2235.156" y1="709.155" x2="2182.529" y2="740.468"/>
          {/* khu vực lối vào hội trường */}
          <rect x="546.563" y="1522.532" transform="matrix(0.9358 0.3525 -0.3525 0.9358 639.8711 -103.3673)" fill="#DBD9D9" width="114.454" height="365.835"/>
          <rect x="2168.534" y="1522.532" transform="matrix(-0.9358 0.3525 -0.3525 -0.9358 4909.7993 2516.9365)" fill="#DBD9D9" width="114.455" height="365.835"/>
              {/* cửa vào hội trường */}
          <path fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" d="M528.645,892.359l-52.938-18.947
            c13.772-18.494,34.556-33.153,60.529-31.941c-21.079-20.747-30.021-40.42-26.176-61.941l50.697,19.646"/>
          <path fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" d="M714.854,1551.953l-20.289,52.439
            c-18.137-14.238-29.191-34.554-27.319-60.488c-21.276,20.543-42.039,28.556-63.456,24.163l18.728-50.588"/>
          <path fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" d="M2115.323,1551.953l20.29,52.439
            c18.137-14.238,29.19-34.554,27.318-60.488c21.276,20.543,42.615,28.455,64.031,24.063l-19.304-50.488"/>
          <path fill="none" stroke="#000000" stroke-width="0.25" stroke-miterlimit="10" d="M2300.677,898.854l52.284-20.912
            c-13.771-18.493-33.8-30.061-59.773-28.85c21.079-20.747,29.266-43.511,25.42-65.033l-50.696,19.646"/>
          {/* khối các mũi tên chỉ hướng đi vào hội trường */}
          <polygon fill="#C6C2C2" points="651.6,1508.395 682.883,1501.765 702.313,1527.162 702.252,1527.327 651.539,1508.56 "/>
          <polygon fill="#6D6C6C" points="660.213,1488.652 691.496,1482.022 710.927,1507.42 710.866,1507.585 660.152,1488.817 "/>
          <polygon points="668.827,1468.909 700.109,1462.28 719.54,1487.677 719.479,1487.843 668.766,1469.075 "/>
          <polygon fill="#C6C2C2" points="2128.836,1527.162 2148.268,1501.765 2179.55,1508.395 2179.611,1508.56 2128.897,1527.327 
          "/>
          <polygon fill="#6D6C6C" points="2120.223,1507.42 2139.654,1482.022 2170.937,1488.652 2170.998,1488.817 2120.284,1507.585 
          "/>
          <polygon points="2111.609,1487.677 2131.041,1462.28 2162.323,1468.909 2162.385,1469.075 2111.671,1487.843 "/>
          <polygon fill="#C6C2C2" points="562.23,824.816 567.002,856.436 540.503,874.334 540.342,874.264 562.069,824.746 "/>
          <polygon fill="#6D6C6C" points="582.415,832.334 587.188,863.954 560.688,881.853 560.526,881.781 582.254,832.264 "/>
          <polygon points="602.6,839.852 607.373,871.472 580.873,889.37 580.712,889.299 602.439,839.781 "/>
          <polygon fill="#C6C2C2" points="163.3,2108.115 168.072,2139.735 141.573,2157.634 141.411,2157.563 163.138,2108.045 "/>
          <polygon fill="#6D6C6C" points="183.485,2115.634 188.257,2147.253 161.758,2165.151 161.596,2165.081 183.323,2115.563 "/>
          <polygon points="203.67,2123.151 208.442,2154.771 181.943,2172.669 181.781,2172.599 203.509,2123.08 "/>
          <polygon fill="#C6C2C2" points="2685.689,2157.634 2659.189,2139.735 2663.962,2108.115 2664.124,2108.045 2685.851,2157.563 
          "/>
          <polygon fill="#6D6C6C" points="2665.504,2165.151 2639.005,2147.253 2643.777,2115.634 2643.938,2115.563 2665.666,2165.081 
          "/>
          <polygon points="2645.319,2172.669 2618.82,2154.771 2623.592,2123.151 2623.754,2123.08 2645.48,2172.599 "/>
          <polygon fill="#C6C2C2" points="2285.684,874.334 2259.184,856.436 2263.956,824.816 2264.118,824.746 2285.845,874.264 "/>
          <polygon fill="#6D6C6C" points="2265.498,881.853 2238.999,863.954 2243.771,832.334 2243.933,832.264 2265.66,881.781 "/>
          <polygon points="2245.313,889.37 2218.814,871.472 2223.586,839.852 2223.748,839.781 2245.475,889.299 "/>
          
        </g>
    </>
  );
}

export default StrokeCS;
